// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root-user-home-page{
    margin: 0px;
    padding: 0px;
    height: 100vh;
    box-sizing: border-box;
    font-family:Verdana, Geneva, Tahoma, sans-serif;
}
.root-user-home-page-layout{
    height: 90%;
    box-sizing: border-box;
    display: grid;
    grid-template-columns: auto 1fr;
}
.root-user-home-page-parent-container{
    display: flex;
    align-items: center;
    justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/RootUserStyles/HomePage/HomePage.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,+CAA+C;AACnD;AACA;IACI,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,+BAA+B;AACnC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B","sourcesContent":[".root-user-home-page{\n    margin: 0px;\n    padding: 0px;\n    height: 100vh;\n    box-sizing: border-box;\n    font-family:Verdana, Geneva, Tahoma, sans-serif;\n}\n.root-user-home-page-layout{\n    height: 90%;\n    box-sizing: border-box;\n    display: grid;\n    grid-template-columns: auto 1fr;\n}\n.root-user-home-page-parent-container{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
